export default __webpack_public_path__ + "images/Taruvi_text_transparent.c9bc7139ad395baa1c79508b04c6697d.png";